import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import RegistrationTimesRepository from '../../repositories/RegistrationTimesRepository';
import RegistrationTimesDataRepository from '../../../data/repositories/RegistrationTimesRepository';

export default function* getRegistrationTimes(action: any): any {
  try {
    const { courseId } = action;
    yield put({ type: Types.GET_REGISTRATION_TIMES_REQUEST, courseId });

    const registrationTimes: RegistrationTimesRepository =
      new RegistrationTimesDataRepository();
    const registrationTimesResponse = yield call(
      registrationTimes.getRegistrationTimes,
      courseId,
      action.campus,
      action.career,
      action.plan,
      action.prog,
      action.period
    );

    if (!registrationTimesResponse) {
      yield put({
        type: Types.GET_REGISTRATION_TIMES_FAILURE,
        courseId,
        isLoading: false,
        isSuccess: false,
        error: true
      });
      return;
    }
    yield put({
      type: Types.GET_REGISTRATION_TIMES_SUCCESS,
      courseId,
      isLoading: false,
      isSuccess: true,
      data: registrationTimesResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_REGISTRATION_TIMES_FAILURE,
      courseId: action.courseId,
      isLoading: false,
      isSuccess: false,
      error: 'Ocurrió un error al obtener los datos de horarios de cursos.'
    });
  }
}
